/** Canonical speaker display names — keep in sync with backend speaker_display_names.py */

export const DEFAULT_SPEAKER_LABEL_MAP: Record<string, string> = {
  SPEAKER_00: 'Бауржан',
  SPEAKER_01: 'Бауржан',
  SPEAKER_02: 'Исламбек',
  SPEAKER_03: 'Абылайхан',
  SPEAKER_04: 'Абылайхан',
  SPEAKER_05: 'Бауржан',
  SPEAKER_06: 'Алдияр',
  SPEAKER_07: 'Исламбек',
  SPEAKER_08: 'Акимжан',
  SPEAKER_09: 'Абылайхан',
};

const SPEAKER_TEXT_REPLACEMENTS: [string, string][] = [
  ['Муканов Бауржан', 'Бауржан'],
  ['Муканов Б.Б.', 'Бауржан'],
  ['Муканов Б. Б.', 'Бауржан'],
  ['Муканов Б Б', 'Бауржан'],
  ['Abylaykhan', 'Абылайхан'],
  ['Abylaikhan', 'Абылайхан'],
  ['Islambek', 'Исламбек'],
  ['Aldiyar', 'Алдияр'],
  ['Akimzhan', 'Акимжан'],
  ['Akimjan', 'Акимжан'],
];

const SPEAKER_NAME_ALIASES: Record<string, string> = {
  'муканов бауржан': 'Бауржан',
  'муканов б.б.': 'Бауржан',
  'муканов б. б.': 'Бауржан',
  'муканов б б': 'Бауржан',
  abylaikhan: 'Абылайхан',
  abylaykhan: 'Абылайхан',
  islambek: 'Исламбек',
  aldiyar: 'Алдияр',
  бауржан: 'Бауржан',
  исламбек: 'Исламбек',
  абылайхан: 'Абылайхан',
  алдияр: 'Алдияр',
  akimzhan: 'Акимжан',
  akimjan: 'Акимжан',
  акимжан: 'Акимжан',
};

const LABEL_KEY_RE = /^(?:SPEAKER|Speaker|Спикер|спикер)[_\s]*(\d{1,2})$/i;
const SPEAKER_LABEL_TOKEN_RE = /(?:SPEAKER|Speaker|Спикер|спикер)[_\s]*(\d{1,2})(?!\d)/gi;

export function speakerLabelKey(name: string): string | null {
  const m = name.trim().match(LABEL_KEY_RE);
  if (!m) return null;
  return `SPEAKER_${String(Number(m[1])).padStart(2, '0')}`;
}

export function canonicalizeSpeakerDisplayName(name: string): string {
  const cleaned = name.replace(/\s+/g, ' ').trim();
  if (!cleaned) return '';

  const labelKey = speakerLabelKey(cleaned);
  if (labelKey && DEFAULT_SPEAKER_LABEL_MAP[labelKey]) {
    return DEFAULT_SPEAKER_LABEL_MAP[labelKey];
  }

  const key = cleaned.toLowerCase();
  if (SPEAKER_NAME_ALIASES[key]) return SPEAKER_NAME_ALIASES[key];
  for (const [old, replacement] of SPEAKER_TEXT_REPLACEMENTS) {
    if (old.toLowerCase() === key) return replacement;
  }
  return cleaned;
}

export function normalizeSpeakerNamesInText(text: string): string {
  if (!text) return '';
  let result = text;
  for (const [old, replacement] of SPEAKER_TEXT_REPLACEMENTS) {
    result = result.split(old).join(replacement);
  }
  result = result.replace(/\bМуканов\b/g, 'Бауржан');
  result = result.replace(SPEAKER_LABEL_TOKEN_RE, (_match, num: string) => {
    const key = `SPEAKER_${String(Number(num)).padStart(2, '0')}`;
    return DEFAULT_SPEAKER_LABEL_MAP[key] ?? _match;
  });
  return result;
}
